import { PhysicalInfo } from '@/entities/physical';
import router from '@/router';
import { PhysicalBaseService } from '@/services/physical.base';
import { UserModule } from '@/store/modules/user';
import { Notify } from 'vant';

/**
 * Physical
 */
export class PhysicalService extends PhysicalBaseService<any, any, any, any> {
    /**
     * 获取人员信息
     */
    public async getInfo(): Promise<PhysicalInfo | any> {
        const json: any = await this.client({
            url: this.path + '/getLastYearData/',
            method: 'post',
        });
        if (json.code === 1) {
            router.replace('/NoAuthentication');
        } else {
            if (json.data) {
                return json.data as unknown as Promise<PhysicalInfo | null>;
            } else {
                // 登出
                await UserModule.LogOut(false);
                await UserModule.reLogin();
                return null;
            }
        }
    }
    /**
     * 修改用户信息
     * @param form
     */
    public async modifyUserInfo(form: any): Promise<any> {
        const json = await this.client({
            url: this.path + '/modifyUserInfo/',
            method: 'post',
            params: form,
        });
        return json as unknown as Promise<any>;
    }
    /**
     * 选择医院
     * @param form
     */
    public async physicalOrder(form: any): Promise<any> {
        const json = await this.client({
            url: this.path + '/physicalOrder/',
            method: 'post',
            params: form,
        });
        return json as unknown as Promise<any>;
    }
    /**
     * 选择医院
     * @param form
     */
    public async getAmountByHospitalId(hospitalId: number): Promise<any> {
        const json = await this.client({
            url: this.path + '/getAmountByHospitalId/',
            method: 'post',
            params: { hospitalId },
        });
        return json as unknown as Promise<any>;
    }
}

const physicalService = new PhysicalService('/hodgepodge/physical');
export default physicalService;
